function LayoutWithUnauthen({ children }) {
  return (
    <div className="center-login gray-bg login-container">
      <div className="login animated fadeInDown ">{children}</div>
    </div>
  );
}

export default LayoutWithUnauthen;
